import { Routes, Route, Navigate } from 'react-router-dom';
import { AdminLayout } from './components/layout/AdminLayout';
import { DashboardPage } from './pages/admin/DashboardPage';
import { LoginPage } from './pages/admin/LoginPage';
import { ProductListPage } from './pages/admin/ProductListPage';
import { ProductFormPage } from './pages/admin/ProductFormPage';
import { CategoryListPage } from './pages/admin/CategoryListPage';
import { CategoryFormPage } from './pages/admin/CategoryFormPage';
import { InquiryListPage } from './pages/admin/InquiryListPage';
import { InquiryDetailPage } from './pages/admin/InquiryDetailPage';
import { UserListPage } from './pages/admin/UserListPage';
import { UserDetailPage } from './pages/admin/UserDetailPage';
import { FAQManagementPage } from './pages/admin/FAQManagementPage';
import { TestimonialManagementPage } from './pages/admin/TestimonialManagementPage';
import { BannerManagementPage } from './pages/admin/BannerManagementPage';
import { ContactListPage } from './pages/admin/ContactListPage';
import { CatalogueManagementPage } from './pages/admin/CatalogueManagementPage';
import { SettingsPage } from './pages/admin/SettingsPage';

function App() {
  return (
    <Routes>
      {/* Admin Login */}
      <Route path="/login" element={<LoginPage />} />

      {/* Protected Admin Routes */}
      <Route element={<AdminLayout />}>
        <Route path="/" element={<DashboardPage />} />

        {/* Product Management */}
        <Route path="/products" element={<ProductListPage />} />
        <Route path="/products/new" element={<ProductFormPage />} />
        <Route path="/products/:id" element={<ProductFormPage />} />

        {/* Category Management */}
        <Route path="/categories" element={<CategoryListPage />} />
        <Route path="/categories/new" element={<CategoryFormPage />} />
        <Route path="/categories/:id" element={<CategoryFormPage />} />

        {/* Inquiry Management */}
        <Route path="/inquiries" element={<InquiryListPage />} />
        <Route path="/inquiries/:id" element={<InquiryDetailPage />} />

        {/* User Management */}
        <Route path="/users" element={<UserListPage />} />
        <Route path="/users/:id" element={<UserDetailPage />} />

        {/* Content Management */}
        <Route path="/content" element={<Navigate to="/content/contacts" replace />} />
        <Route path="/content/faqs" element={<FAQManagementPage />} />
        <Route path="/content/testimonials" element={<TestimonialManagementPage />} />
        <Route path="/content/banners" element={<BannerManagementPage />} />
        <Route path="/content/contacts" element={<ContactListPage />} />
        <Route path="/content/catalogues" element={<CatalogueManagementPage />} />

        {/* Settings */}
        <Route path="/settings" element={<SettingsPage />} />
      </Route>
    </Routes>
  );
}

export default App;
